import { render, staticRenderFns } from "./OrderDocumentUploader.vue?vue&type=template&id=4a094450&scoped=true&"
import script from "./OrderDocumentUploader.vue?vue&type=script&lang=js&"
export * from "./OrderDocumentUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a094450",
  null
  
)

export default component.exports